module.exports = {
  showlabel: 'MENU', // ALL： 全部加载label上面,MENU: 只有左侧菜单加载label上面
}